<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">KPI Comparison</h1>
      <p>
        After the comparison analysis has run smoothly, this page
      </p>

    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>
